import Vue from "vue";
import { sync } from "vuex-router-sync";
import VueI18n from "vue-i18n";

import "./styles/index.scss";
import "./directives";
import "./filters";
import "./components";

import App from "./App.vue";
import router from "./router";
import runRouterHooks from "./router/hooks";
import store from "./store";
import vuetify from "./plugins/vuetify";
import messages from "./common/config/i18n";

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: "en",
  formatFallbackMessages: true,
  messages,
});
runRouterHooks(store);
sync(store, router);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App),
}).$mount("#app");
